<template>
    <div class="container-fluid p-5" style="font-family: Arial;">
    <div class="row">
            <div class="col-md-8 mx-auto">
        <div v-for="(item, index) in admissions" :key="index">
          <center><img src="@/assets/images/header.png" height="150"/></center><br>
          <div class="d-flex justify-content-between my-4">
            <div class="mt-5">
                <b class="text-danger">{{ item.details.studentname }}</b><br>
                <b class="text-danger">Tel: {{ item.details.telephone }}</b><br><br>
                <u><span> ADMISSION LETTER FOR ACADEMIC YEAR {{ item.registrations[0].year }}</span></u>
            </div>
            <div class="">
                <b class="text-black">Date: {{ currentdate }}</b><br>
                <div class="bg-warning" style="width: 120px;height: 120px;"></div>
            </div>
           </div>
           <div class="">
            <b>Dear</b><br>
            Mr./Mrs.Miss./Dr. ..................................... Date <b class="text-black">{{ item.details.registration_date }}</b><br>
            <b class="text-black">RE: ADMISION TO <u style="text-decoration: dotted;">MotherwellSchools</u>  {{ item.registrations[0].year }}</b><br>
            <span>
                On behalf of the Motherwell Admissions Office, we are glad to inform you that you have been admitted to the school. <br>
                Congratulations! You will report on <b class="text-black">{{ item.details.registration_date }}</b> at MotherwellSchools Mutungo. <br>
                I am glad to inform you that your child <b class="text-black">{{ item.details.studentname }}</b> has been admitted to <b class="text-black">{{ item.registrations[0].class.name }}</b> at MotherwellSchool, Mutungo Hill, Kampala. Let me take this opportunity to congratulate you! <br>
                Your admission to this school has been purely on merit and you are expected to maintain this good performance. <br>
                The reporting date is <b class="text-black">{{ item.details.registration_date }}</b> between 8:00a.m and 5:00p.m. There will be no one to receive you beyond 5:00p.m. On failure to report on this indicated date above you can report on any other working day during working hours. <br>
                <u><b class="text-black">Failure</b></u> to report within a fortnight from the official date is an indication that you are no longer interested and therefore your vacancy will be given away to another interested person. <br>
            </span><br>
            <span>
                <u><b class="text-black">REGISTRATION:</b></u><br>
                The following are required for registration on arrival: <br>
                <u><b class="text-black">PERSONAL REQUIREMENTS FOR BOARDERS:</b></u>
                <div class="row">
                    <div class="col-md-6">
                        <ul>
                        <li>A pair of bed sheets</li>
                        <li>A mat</li>
                        <li>A blanket</li>
                        <li>A basin</li>
                        <li>A comb</li>
                        <li>3 bars of washing soap</li>
                        <li>10 liter Jerrycan</li>
                        <li>3 tins of Vaseline</li>
                        <li>Polythene cover (for those who wet on beds)</li>
                        <li>Torch</li>
                        </ul>
                    </div>
                    
                    <div class="col-md-6">
                        <ul>
                            <li>A plate and cup</li>
                            <li>Tooth brush</li>
                            <li>3 packets of toothpaste</li>
                            <li>pair of slippers</li>
                            <li>Black shoe and polish</li>
                            <li>3 pieces of bathing soap</li>
                            <li>Sponge/ roofah</li>
                            <li>Sanitary towels (girls)</li>
                        </ul>
                    </div>
                </div>
                <center><i> NB: Mattresses will be provided by the school for all Boarding pupils. </i></center>
                <u><b class="text-black">2. GENERAL REQUIREMENTS</b></u>
                <ol>
                    <li>3 passport sized photographs for each applicant (pupils).</li>
                    <li>P1 – P3:   12 books (96 pages picfare), 6 pencils, 4 rolls of toilet papers, 1 packet of coloured pencils, school bag, 6 pens (for P3)</li>
                    <li>P4 – P5: 24 books (96 pages picfare) 6 pencils, 6 pens, 4 rolls of toilet papers, 1 packet of coloured pencils, a ream of Rotatrim clip papers, geometry set, school bag and 6 black books.</li>
                    <li>P6 – P7: 36 books (96 pages picfare), 12 pens, 12 pencils, 4 rolls of toilet papers, geometry set, packet of coloured pencils, ream of Rotatrim clip papers, school bag and 6 black books.</li>
                </ol>
               <center> <b class="text-black">Thank you for showing interest to work with us. <br>
                <i>‘ALUTA CONTINUA’</i> </b></center> <br>
                …………………………………………………… <br>
                <b class="text-black"> FOR: HEAD TEACHER </b>
            </span>
           </div>
        </div>
    </div>
    </div>
    </div>
</template>
  
  <script>
  import axios from "axios";
  import appConfig from "@/app.config";
  export default {
    page: {
      title: "Application ",
      meta: [{name: "description",content: appConfig.description}],
    },
    data() {
      return {
      userData: JSON.parse(localStorage.getItem("client")),
      token: localStorage.getItem("token"),
      currentdate:new Date().toLocaleDateString('fr-CA'),
      options : { weekday: "long", year: "numeric", month: "long", day: "numeric",},
      loader:false,
      admissions:[],
      };
    },
    created() { this.fetchAdmission(); },
    methods: {
      async fetchAdmission(){
        this.admissionnumber=this.$route.query.id;
        let url = `/myadmission/${this.admissionnumber}`;
        await axios.get(url).then((response) => {
          this.admissions = response.data.admissions;
          setTimeout(() => { window.print(); window.onafterprint=this.$router.go(-1); }, 3000);
        });
      },
    },
  };
  </script>